import React, { useState } from 'react';
import text from '../lib/dictionary.json';
import { useAuth } from '../AuthProvider';
import ShowIcon from '@mui/icons-material/VisibilityOff';
import HideIcon from '@mui/icons-material/Visibility';
import { AXIOS_OPTIONS, BASE_URL_API } from '../Constants';
import axios from 'axios';
import './modal.css';
import { CheckIcon, DashedLineSeparator } from '../Icons';


const DANGER = '#DC2626';

const ChangePassword = ({ state, setState, mandatory, backgroundColor, color }) => {
    const { lang, user, setUser, setAlertState } = useAuth();
    const [clicked, setClicked] = useState(false);
    const [passwordState, setPasswordState] = useState({
        newPassword: '', 
        confirmPassword: '',
        oldPassword: '',
        status: 'very weak',
        showPassword: false,
        showNewPassword: false,
        showConfirmPassword: false,
    });

    const evaluatePassword = (password) => {
        let score = 0;
        if (password?.length >= 8) score += 1;
        if (/[a-z]/.test(password)) score += 1;
        if (/[A-Z]/.test(password)) score += 1;
        if (/\d/.test(password)) score += 1;
        if (/[^A-Za-z0-9]/.test(password)) score += 1;

        switch (score) {
            case 2: return 'weak';
            case 3: return 'medium';
            case 4: return 'good';
            case 5: return 'great';
            default: return 'very weak';
        }
    }

    const passwordStrength = evaluatePassword(passwordState.newPassword);
    const isLengthValid = passwordState.newPassword?.length >= 8;
    const isStrong = passwordStrength !== 'very weak' && passwordStrength !== 'weak';
    const isOldPasswordEntered = passwordState.oldPassword?.length > 0;

    const canUpdate = isLengthValid && isStrong  && isOldPasswordEntered;

    const changePassword = () => {
        if (!canUpdate) return;

        setClicked(true);
        const expiry = new Date();
        expiry.setMonth(expiry.getMonth() + 3);
        axios.post(
            BASE_URL_API + '/user/update/' + state.userId,
            JSON.stringify({ password: passwordState.newPassword, password_expiry: expiry.toString() }),
            AXIOS_OPTIONS
        ).then(res => {
            setAlertState({ open: true, message: text[lang]['password-success'], type: 'success' });
            const newUser = { ...user, password_expiry: expiry.toString() };
            setUser(newUser);
            localStorage.setItem('crm-user', JSON.stringify(newUser));
        }).catch(
            err => setAlertState({ open: true, message: err.response?.data?.message ?? err.message, type: 'error' })
        ).finally(() => {
            setClicked(false);
            setState({ open: false, userId: 0 });
        });
    };

    return (
        <div id='modal' >
            <div id='popup' onClick={(e) => e.stopPropagation()} style={{
                width: '45rem',
                height: 'fit-content',
            }}>
                <div style={{
                    width: '100%',
                    background: `
                     radial-gradient(120% 80% at 50% 0%,
                     var(--app-gradient-1) 0,
                     var(--app-gradient-2) 30%,
                     var(--root-background-color) 60%)`,
                    color: color || 'var(--cell-color)',
                }}>
                    <div className='modal-header' style={{
                        justifyContent: 'space-between',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        width: '100%',
                        paddingBottom:0

                    }}>
                        <h2 style={{
                            textAlign: lang === 'en' ? 'left' : 'right',
                            fontSize: 'var(--large)', fontWeight: 'bold', color: '#111827'
                        }}>{text[lang]['change-password']}</h2>
                        <p style={{
                            fontSize: 'var(--small)',
                            color: '#576573'
                        }}>{text[lang]['change-password-description']}</p>
                        <div style={{
                            width:'45rem',
                            padding:'0 2.75rem'
                        }}>
                        <DashedLineSeparator/>
                        </div>
                    </div>
                    <div className='' style={{
                        width: '100%',
                        padding: '0 2.75rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1rem',
                        marginTop: '2.125rem'
                    }}>
                        <FormItem label={text[lang]['your-password']} value={passwordState?.oldPassword || ''} lang={lang}
                            show={passwordState.showPassword}
                            OnChange={(e) => setPasswordState({ ...passwordState, oldPassword: e.target.value })}
                            setShow={() => setPasswordState({ ...passwordState, showPassword: !passwordState.showPassword })}
                        />

                        <FormItem label={text[lang]['password-label']} value={passwordState?.newPassword || ''} lang={lang}
                            show={passwordState.showNewPassword}
                            setShow={() => setPasswordState({ ...passwordState, showNewPassword: !passwordState.showNewPassword })}
                            helper={text[lang]['password-helper']}
                            OnChange={(e) => setPasswordState({ ...passwordState, newPassword: e.target.value })}
                            // عرض خطأ إذا كانت ضعيفة
                            error={passwordState.newPassword && !isStrong ? "Password is too weak" : null}
                        />

                        {/* <FormItem label={text[lang]['re-turn-new-password']} value={passwordState?.confirmPassword || ''} lang={lang}
                            show={passwordState.showConfirmPassword}
                            OnChange={(e) => setPasswordState({ ...passwordState, confirmPassword: e.target.value })}
                            setShow={() => setPasswordState({ ...passwordState, showConfirmPassword: !passwordState.showConfirmPassword })}
                            // عرض خطأ إذا لم تتطابق
                            error={passwordState.confirmPassword && !isMatching ? "Passwords do not match" : null}
                        /> */}
                    </div>
                    <div className='' style={{
                        // flexDirection: lang === 'en' ? 'row' : 'row-reverse',
                        display: 'flex',
                        margin: '2.125rem',
                        justifyContent: 'flex-end',
                        gap: '0.5rem'
                    }}>
                        {!mandatory && <button className='modal-btn modal-cancel-btn' onClick={() => setState({ open: false, userId: 0 })}>{text[lang]['cancel']}</button>}
                        <button 
                            className='modal-btn modal-add-btn' 
                            onClick={changePassword}
                            disabled={!canUpdate || clicked}
                            style={{ 
                                opacity: canUpdate ? 1 : 0.5, 
                                cursor: canUpdate ? 'pointer' : 'not-allowed' 
                            }}
                        >
                            {clicked ? '...' : text[lang]['update']}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};


const FormItem = ({ label, value, lang, OnChange, show, setShow, helper, error, placeholder }) => {
    return (
        <div className='form-item' style={{ width: '100%', flexDirection: 'column', display: 'flex', alignItems: lang === 'en' ? 'flex-start' : 'flex-end', gap: 8 }}>
            <div style={{ width: '100%' }}>
                <label className='' style={{
                    fontSize: 'var(--medium)',
                    fontWeight: 'bold',
                    color: '#111827'
                }}>{label}</label>

                <div className='field-wrapper' style={{
                    width: '100%',
                    marginTop: 2,
                    position: 'relative'
                }}>
                    <input type={show ? 'text' : 'password'} className=''
                        placeholder={placeholder} value={value}
                        style={{
                            textAlign: lang === 'en' ? 'left' : 'right',
                            height: '3.188rem',
                            borderRadius: '0.5rem',
                            border: error ? `1px solid ${DANGER}` : '1px solid #829AB1',
                            width: '100%',
                            padding: '0 1rem',
                            background:'rgba(255,255,255,0.8)'

                        }}
                        onChange={OnChange} />

                    <span className='search-icon' style={{ 
                        position: 'absolute',
                        right: lang === 'en' ? '5%' : 'unset',
                        left: lang === 'en' ? 'unset' : '5%',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        pointerEvents: 'auto', 
                        cursor: 'pointer',
                        display: 'flex'
                    }}
                        onClick={setShow}
                    >
                        {show ? <ShowIcon /> : <HideIcon />}
                    </span>
                </div>
                {/* إضافة رسالة الخطأ أو الهيلبر بنفس الستايل */}
                {error ? (
                    <div style={{ color: DANGER, fontSize: 'var(--x-small)', marginTop: '4px' }}>{error}</div>
                ) : helper && (
                    <div style={{ color: '#6B7280', fontSize: 'var(--x-small)', display: 'flex', gap: '0.313rem', marginTop: '4px' }}>
                        <CheckIcon/>
                        <span>{helper}</span>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ChangePassword;